<template>
  <v-row justify="center" dense>
    <v-col cols="12" sm="6" md="3">
      <v-select
        :items="transportTypes"
        item-text="name"
        item-value="id"
        v-model="contextTransportType"
        :error-messages="modelTransportTypeValidation"
        :label="$t('delegation.form.fields.transport.transportType.name')"
        :readonly="$store.state.Delegation.readonly === true"
        persistent-hint
        :hint="validationTransportType"
        :background-color="validationTransportType !== null ? 'blue lighten-5' : null"
      />
    </v-col>
    <v-col cols="12" sm="6" md="3" v-if="modelTransportType !== 1">
      <v-select
        :items="settlementTypes(modelTransportType)"
        v-model="contextSettlementTypeId"
        :error-messages="modelSettlementTypeIdValidation"
        :label="$t('delegation.form.fields.transport.settlementType.name')"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6">
      <v-text-field
        :label="$t('delegation.form.fields.transport.comment.name')"
        v-model="contextComment"
        :error-messages="modelCommentValidation"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
  </v-row>
</template>

<script>
import TransportTypes from "../../../../staticData/TransportTypes";
import SettlementTypes from "../../../../staticData/TransportSettlementTypes";
import ValidationTransportType from "./validationTransportType";

export default {
  name: "FirstRowTransportSettlementAlreadySettled",
  props: {
    modelTransportType: {
      required: true
    },
    modelSettlementTypeId: {
      required: true
    },
    modelComment: {
      required: true
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelSettlementTypeIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelCommentValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    filePropertiesLocal: []
  }),
  computed: {
    validationTransportType: function() {
      return ValidationTransportType(this);
    },
    transportTypes: TransportTypes,
    contextTransportType: {
      set: function(value) {
        this.$emit("update:modelTransportType", value);
      },
      get: function() {
        return this.modelTransportType;
      }
    },
    contextSettlementTypeId: {
      set: function(value) {
        this.$emit("update:modelSettlementTypeId", value);
      },
      get: function() {
        return this.modelSettlementTypeId;
      }
    },
    contextComment: {
      set: function(value) {
        this.$emit("update:modelComment", value);
      },
      get: function() {
        return this.modelComment;
      }
    }
  },
  methods: {
    settlementTypes: SettlementTypes
  }
};
</script>

<style scoped></style>
